import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import { CopyLinkButton } from './components/CopyLinkButton/index_new';
import { EditURLButton } from './components/EditURLButton';
import { useShareUrl } from './hooks/useShareUrl/index_new';

export function ShareUrl(): JSX.Element {
	const { data, actions } = useShareUrl();
	const { translate } = useI18n();

	return (
		<div data-testid="share-url" className="rounded-small bg-background-overlay flex flex-col gap-2 p-2">
			<div className="rounded-small bg-background-base px-4 py-2">
				<Text className="text-size-body-xs">Your unique Link</Text>
				<div className="flex flex-row items-center justify-between">
					<Text
						aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.short_url_aria_label')}
						data-testid="copylink-input"
						className="text-size-body-small-bold max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap"
					>
						{data.shareUrl}
					</Text>
					{data.canEditUrl && <EditURLButton data-qa="edit-url-button" onEditUrl={actions.onEditUrl} />}
				</div>
			</div>
			<div>
				<CopyLinkButton shareUrl={data.shareUrl} />
			</div>
		</div>
	);
}
